/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Eficacia genérica: total, exitosos, porcentaje.
 */
export interface EfficiencyDTO { 
    total: number;
    successful: number;
    percentage: number;
}

